/**
 * Use this helper to render a vue component on a page within an element. You can
 * pass one or more elements to render as an object as the components argument.
 * Usage:
 * 
 * renderComponent('#some-element-wrapper', { MyComponent });
 */
import Vue from 'vue/dist/vue.esm'

export default function renderComponent(elementId, components) {
  document.addEventListener('DOMContentLoaded', () => {
    new Vue({
      el: elementId,
      components: components
    });
  });
}
